import { render, staticRenderFns } from "./StudipDateTime.vue?vue&type=template&id=4abcb354&"
import script from "./StudipDateTime.vue?vue&type=script&lang=js&"
export * from "./StudipDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports